<template>
    <div id="period-filter">
        <fieldset class="datetime">
            <legend>Fra tidspunkt</legend>
            <div>
                <label for="startdate"><span class="muted">Dato</span></label>
                <input 
                    id="startdate"
                    type="date" 
                    v-model="startdate"
                    pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                    placeholder="f.eks. 2019-06-31"
                    @change="emitChange()">
            </div>
            <div>
                <label for="starttime"><span class="muted">Tid</span></label>
                <input 
                    id="starttime"
                    type="time"
                    v-model="starttime"
                    pattern="[0-9]{2}:[0-9]{2}"
                    placeholder="f.eks. 09:30"
                    @change="emitChange()">    
            </div>
        </fieldset>
        <p class="error" v-if="error">{{ error }}</p>
        <fieldset class="datetime">
            <legend>Til tidspunkt</legend>
            <div>
                <label for="enddate"><span class="muted">Dato</span></label>
                <input 
                    id="enddate"
                    type="date" 
                    v-model="enddate"
                    pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}"
                    placeholder="f.eks. 2019-12-31"
                    @change="emitChange()">
            </div>
            <div>
                <label for="endtime"><span class="muted">Tid</span></label>
                <input 
                    id="endtime"
                    type="time"
                    v-model="endtime"
                    pattern="[0-9]{2}:[0-9]{2}"
                    placeholder="f.eks. 14:45"
                    @change="emitChange()">
            </div>
        </fieldset>    
    </div>
</template>

<script>

    import { dateJs2django } from '../../../utils/Filters.js'

    export default {
        data: function() {
            return {
                startdate: null,
                starttime: '07:00',
                startdatetime: null,
                enddate: null,
                endtime: '21:30',
                enddatetime: null,
                error: null
            }
        },
        methods: {
            emitChange: function() {

                this.error = null

                if (this.startdate && !this.enddate) {
                    this.enddate = this.startdate
                } else if (!this.startdate && this.enddate) {
                    return
                } else if (this.startdate > this.enddate) {
                    this.error = '"Til" tidspunkt må ikke være før "Fra"'
                    return
                }
                
                this.startdatetime = dateJs2django( this.processDateTime(this.startdate, this.starttime) )
                this.enddatetime = dateJs2django( this.processDateTime(this.enddate, this.endtime) )

                this.$emit('filter', { 
                    'start': encodeURIComponent( this.startdatetime ),
                    'end': encodeURIComponent( this.enddatetime )
                })
                
            },
            processDateTime: function(date, time) {
                if (!date && !time) {
                    return null
                }
                let dt_obj = new Date()
                if (date) {
                    const d = date.split('-')
                    dt_obj.setFullYear(d[0], d[1] - 1, d[2])
                }
                if (time) {
                    const t = time.split(':')
                    dt_obj.setHours(t[0], t[1])
                }
                return dt_obj
            }
        }
    }

</script>

<style lang="scss">

    #period-filter {

        .datetime {
            display: flex;
            flex-flow: row nowrap;
            align-items: center;
            margin: 0;

            div {
                margin: 0 .5rem 0 0;
            }
        }
    }

</style>